export const BACKEND =
  (import.meta as any).env?.PROD
    ? "https://api.ilzhoefer-technik.de/api/v1"
    : "/backend/api/v1";
export const STRONGBACKEND = "https://api.ilzhoefer-technik.de";
export const BILDERBACKEND = "https://api.ilzhoefer-technik.de/App_Data/UploadData";
export const APPBACKEND = "https://app.ilzhoefer-technik.de";
export const APIVERSION = "v1";